import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-989eb806"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Contact Me", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Feel free to reach out to me for any questions you might have. ", -1))
const _hoisted_4 = { id: "Info" }
const _hoisted_5 = { class: "email" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Email ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createElementVNode("address", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "mailto:hrishikesh.karale@gmail.com" }, " hrishikesh.karale@gmail.com ")
  ])
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, " * Feel free to send me an email any time of the day and I should be able to respond in a reasonable amount of time. ", -1))
const _hoisted_9 = { class: "phone" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Phone Number ")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createElementVNode("address", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "tel:585-520-7382" }, " (585) 520-7382 ")
  ])
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Hours: 8am - 4pm (EST), everyday.", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, [
  /*#__PURE__*/_createTextVNode(" * Text messages prefered. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" * First time caller(s) are screened using virtual assistan to weed out spam calls ")
], -1))
const _hoisted_14 = { class: "address" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Postal Address ")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("address", null, [
  /*#__PURE__*/_createTextVNode(" 44 Crittenden Way, "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Apartment 2, "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Rochester, NY 14623. ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_text_input = _resolveComponent("text-input")!
  const _component_email_input = _resolveComponent("email-input")!
  const _component_phone_input = _resolveComponent("phone-input")!
  const _component_checkbox_input = _resolveComponent("checkbox-input")!
  const _component_vue_textarea = _resolveComponent("vue-textarea")!
  const _component_vue_form = _resolveComponent("vue-form")!
  const _component_vue_modal = _resolveComponent("vue-modal")!
  const _component_vue_clipboard = _resolveComponent("vue-clipboard")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("header", null, [
      _hoisted_2,
      _createVNode(_component_vue_modal, {
        tag: "loginScreen",
        text: "Form",
        display: _ctx.showForm,
        onDisplay: _cache[9] || (_cache[9] = 
					val => {
						_ctx.showForm = val;
					}
				)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_vue_form, {
            ctx: _ctx.sendMail.bind(this),
            tag: "contactForm",
            title: "Contact Form",
            description: "Please fill out the form and Hrishikesh will get in touch with you in a few days.",
            alertID: { parent: 'contactForm', child: null },
            alertMessage: 
						_ctx.alertObject
							.filter(
								alert =>
									(alert.src.parent === 'contactForm') &
									(alert.src.child === null)
							)
							.pop()
					,
            validate: !_ctx.booleanTrue,
            isAutocomplete: _ctx.booleanTrue
          }, {
            default: _withCtx(() => [
              _createVNode(_component_text_input, {
                modelValue: _ctx.sender,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sender) = $event)),
                label: "Name",
                tag: "senderName",
                placeholder: "John Doe",
                isRequired: _ctx.booleanTrue,
                alertID: { parent: 'contactForm', child: 'senderName' },
                alertMessage: 
							_ctx.alertObject
								.filter(
									alert =>
										(alert.src.parent === 'contactForm') &
										(alert.src.child === 'senderName')
								)
								.pop()
						,
                onValue: _cache[1] || (_cache[1] = val => (_ctx.sender = val)),
                onNotify: _ctx.alert
              }, null, 8, ["modelValue", "isRequired", "alertMessage", "onNotify"]),
              _createVNode(_component_email_input, {
                modelValue: _ctx.email,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email) = $event)),
                label: "Email",
                tag: "senderEmail",
                placeholder: "JDoe@email.com",
                icon: "far fa-envelope",
                isRequired: _ctx.booleanTrue,
                alertID: { parent: 'contactForm', child: 'senderEmail' },
                alertMessage: 
							_ctx.alertObject
								.filter(
									alert =>
										(alert.src.parent === 'contactForm') &
										(alert.src.child === 'senderEmail')
								)
								.pop()
						,
                onValue: _cache[3] || (_cache[3] = val => (_ctx.email = val)),
                onNotify: _ctx.alert
              }, null, 8, ["modelValue", "isRequired", "alertMessage", "onNotify"]),
              _createVNode(_component_phone_input, {
                modelValue: _ctx.phone,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.phone) = $event)),
                label: "Phone number",
                tag: "senderPhone",
                placeholder: "(555) 555-5555",
                alertID: { parent: 'contactForm', child: 'senderPhone' },
                alertMessage: 
							_ctx.alertObject
								.filter(
									alert =>
										(alert.src.parent === 'contactForm') &
										(alert.src.child === 'senderPhone')
								)
								.pop()
						,
                onValue: _cache[5] || (_cache[5] = val => (_ctx.phone = val)),
                onNotify: _ctx.alert
              }, null, 8, ["modelValue", "alertMessage", "onNotify"]),
              _withDirectives(_createVNode(_component_checkbox_input, {
                type: "radio",
                label: "Preffered means of communication?",
                tag: "modeOfCommunication",
                value: _ctx.preffered,
                options: _ctx.options,
                box: _ctx.booleanTrue,
                isRequired: _ctx.booleanTrue,
                onValue: _cache[6] || (_cache[6] = val => (_ctx.preffered = val))
              }, null, 8, ["value", "options", "box", "isRequired"]), [
                [_vShow, _ctx.phone]
              ]),
              _createVNode(_component_vue_textarea, {
                modelValue: _ctx.comment,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.comment) = $event)),
                label: "message",
                tag: "senderMessage",
                placeholder: "message",
                isRequired: _ctx.booleanTrue,
                alertID: { parent: 'contactForm', child: 'senderMessage' },
                alertMessage: 
							_ctx.alertObject
								.filter(
									alert =>
										(alert.src.parent === 'contactForm') &
										(alert.src.child === 'senderMessage')
								)
								.pop()
						,
                onValue: _cache[8] || (_cache[8] = val => (_ctx.comment = val)),
                onNotify: _ctx.alert
              }, null, 8, ["modelValue", "isRequired", "alertMessage", "onNotify"])
            ]),
            _: 1
          }, 8, ["ctx", "alertMessage", "validate", "isAutocomplete"])
        ]),
        _: 1
      }, 8, ["display"])
    ]),
    _hoisted_3,
    _createElementVNode("section", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h3", null, [
          _hoisted_6,
          _createVNode(_component_vue_clipboard, {
            id: "emailId",
            copy: "hrishikesh.karale@gmail.com",
            category: "icon"
          })
        ]),
        _hoisted_7,
        _hoisted_8
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("h3", null, [
          _hoisted_10,
          _createVNode(_component_vue_clipboard, {
            id: "phoneNumber",
            copy: "5855207382",
            category: "icon"
          })
        ]),
        _hoisted_11,
        _hoisted_12,
        _hoisted_13
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("h3", null, [
          _hoisted_15,
          _createVNode(_component_vue_clipboard, {
            id: "address",
            copy: "44 Crittenden Way,\r\nApartment 2,\r\nRochester, NY 14623.",
            category: "icon"
          })
        ]),
        _hoisted_16
      ])
    ])
  ]))
}